import i18n from "../i18n";

const FALLBACK_AZ = {
    EASY: "Asan",
    MEDIUM: "Orta",
    HARD: "Çətin",
};

const COLORS = {
    EASY: "#22c55e",
    MEDIUM: "#f59e0b",
    HARD: "#ef4444",
};

const NAMES = ["EASY", "MEDIUM", "HARD"];

const labelFor = (name) =>
    i18n.t(`difficulty.${name}`, {defaultValue: FALLBACK_AZ[name] || name});

// Proxy so callers using `DifficultyLevels.EASY.label` get a freshly translated
// label each time they read the field — i18n.t() resolves against the current
// language without callers needing a hook.
export const DifficultyLevels = NAMES.reduce((acc, name) => {
    acc[name] = {
        name,
        color: COLORS[name],
        get label() {
            return labelFor(name);
        },
    };
    return acc;
}, {});

export const getDifficulty = (level) => {
    if (!level) return null;
    const key = String(level).toUpperCase();
    if (!NAMES.includes(key)) return null;
    return DifficultyLevels[key];
};
